import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MatCardModule } from '@angular/material/card';
import { BrowserModule } from '@angular/platform-browser';
import { MatExpansionModule, MatFormFieldModule, MatSelectModule } from '@angular/material';

import { HttpLoaderFactory } from '../shared/shared.module';
import { FullMenuCategoryContainerComponent } from './full-menu-category-container/full-menu-category-container.component';
import { FullMenuComponent } from './full-menu.component';
import { FullMenuHeaderComponent } from './full-menu-header/full-menu-header.component';
import { FullMenuSubOptionComponent } from './full-menu-sub-option/full-menu-sub-option.component';
import { FullMenuOptionComponent } from './full-menu-option/full-menu-option.component';
import { FullMenuOrderComponent } from './full-menu-order/full-menu-order.component';

@NgModule({
  declarations: [
    FullMenuComponent,
    FullMenuHeaderComponent,
    FullMenuCategoryContainerComponent,
    FullMenuOptionComponent,
    FullMenuSubOptionComponent,
    FullMenuOrderComponent,
    
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatCardModule,
    MatSelectModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  exports: [
    FullMenuComponent,
    FullMenuHeaderComponent,
    FullMenuCategoryContainerComponent,
    FullMenuOrderComponent
  ]
})
export class FullMenuModule { }
